import React from 'react';
import {
  MenuItem
} from '@material-ui/core';
import i18n from '../../i18n';
import { employeeTypes } from '../../constants/general';

const employeeTypeMenuItems = employeeTypes.map(employeeType => (
  <MenuItem key={employeeType} value={employeeType}>
    {i18n.t(employeeType)}
  </MenuItem>
));

export default employeeTypeMenuItems;
